<ng-container *ngIf="!isResetEmailSent">
  <dx-validation-group #forgotPasswordValidationGroup>
    <div class="forgot-password-form-wrapper">
      <!-- Username/Email Input -->
      <div class="forgot-password-input-wrapper">
        <label for="txtUsername" class="input-label">
          Username or Email
          <span class="required-asterisk">*</span>
        </label>
        <dx-text-box
          id="txtUsername"
          placeholder="Username or Email"
          [(value)]="forgotPasswordParameterDto.username"
          (onEnterKey)="btnResetPasswordClick($event)"
          class="username-input cc-text-required"
        >
          <dx-validator>
            <dxi-validation-rule
              type="required"
              message="Username or Email is required"
            ></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>

      <!-- reCAPTCHA -->
      <div class="recaptcha-container">
        <re-captcha
          #reCaptcha
          [siteKey]="recaptchaSiteKey"
          errorMode="handled"
          (resolved)="onRecaptchaResolved($event)"
          (errored)="onRecaptchaErrored()"
        ></re-captcha>
        <p *ngIf="recaptchaErrorMessage" class="recaptcha-error-message">
          {{ recaptchaErrorMessage }}
        </p>
      </div>

      <!-- Back to Sign In Button -->
      <div class="back-to-login-container">
        <dx-button
          #btnLogin
          text="Back to Sign In"
          type="default"
          class="back-to-login-button"
          (onClick)="btnBackToLogin($event)"
        ></dx-button>
      </div>

      <!-- Submit Button -->
      <div class="forgot-password-button-wrapper">
        <dx-button
          #btnReset
          text="Submit"
          type="default"
          class="forgot-password-button"
          [disabled]="!recaptchaToken?.length"
          (onClick)="btnResetPasswordClick($event)"
        ></dx-button>
      </div>

      <!-- Sign In Link -->
      <div class="signup-container">
        <span>Already have an account?</span>
        <a (click)="btnBackToLogin($event)">Sign in</a>
      </div>
    </div>
  </dx-validation-group>
</ng-container>

<ng-container *ngIf="isResetEmailSent">
  <div class="success-page-wrapper">
    <!-- Success Icon -->
    <div class="success-icon-container">
      <div class="success-icon">
        <i class="fas fa-check"></i>
      </div>
    </div>

    <!-- Success Message -->
    <div class="success-title">
      Your request has been successfully submitted!
    </div>

    <div class="success-message">
      Please check your email for the reset password link.
    </div>

    <!-- Sign In Link -->
    <div class="signup-container success-signin">
      <span>Already have an account?</span>
      <a (click)="btnBackToLogin($event)">Sign in</a>
    </div>
  </div>
</ng-container>

<dx-load-panel
  #loadPanelLogin
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#loginContainer' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
